import { useState, FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { api } from '../lib/api';

export default function ForgotPassword() {
  const { t } = useTranslation();
  const [email, setEmail]   = useState('');
  const [sent, setSent]     = useState(false);
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setLoading(true);
    try { await api.post('/auth/forgot-password', { email }); } catch {}
    setSent(true); setLoading(false);
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="card">
          <h2 className="text-lg font-semibold mb-2">{t('auth.forgotTitle')}</h2>
          {sent ? (
            <p className="text-sm text-gray-600">{t('auth.resetSent')}</p>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4 mt-4">
              <div>
                <label className="label">{t('auth.email')}</label>
                <input className="input" type="email" required value={email} onChange={e => setEmail(e.target.value)} placeholder="you@example.com" />
              </div>
              <button className="btn-primary w-full" type="submit" disabled={loading}>
                {loading ? t('auth.sending') : t('auth.sendLink')}
              </button>
            </form>
          )}
          <p className="mt-4 text-sm text-center"><Link to="/login" className="text-brand-red hover:underline">{t('auth.backToLogin')}</Link></p>
        </div>
      </div>
    </div>
  );
}
